import { useQuery } from '@tanstack/react-query';

import { fetchCategories } from '../services/svp/categories';

export const useSvpCategories = (params?: Record<string, string>) => {
  return useQuery({
    queryKey: ['svp-categories', params],
    queryFn: () => fetchCategories(params),
    enabled: Boolean(params),
  });
};
